import React, { Component } from 'react'
import Search from './Search'
import { Segment } from 'semantic-ui-react'
import { firestore } from '../../Firebase/firebaseConfig';
import axios from 'axios';
import Details from './Details'
import EditForm from './EditForm';

class Editvendor extends Component {

    state={
        email : '',
        loading : false,
        buttons : false,
        service : '',
        data : '',
        edit : false,
        index : ''
    }

    getDets(e){
        this.setState({ [e.target.name] : e.target.value })
    }
    getService=(event)=>{
        if(event.target.textContent === undefined) return this.setState({service : ""})
        else return this.setState({service : event.target.textContent})
    }

    getOtp=(event)=>{
        this.setState({otpcheck : event.target.value})
    }

    
    gotoEdit=(event)=>{
        this.setState({edit : true})
    }

    componentWillUnmount(){
    this.setState({ otp : '',
    otpcheck : '',
    email : '',
    service: "",
    data : "",
    otpmsg : '',
    edit : false,
    index : ''
    })        
    }


    init=()=>{
         this.setState({ 
            otp : '',
            otpcheck : '',
            email : '',
            service: "",
            data : "",
            otpmsg : '',
            index : ''
        })
    }


    confirmOtp=()=>{
        if(this.state.otp === this.state.otpcheck) {
            this.setState({ success : true,otp : '',otpmsg: '' })
        }

        else return this.setState({ otpmsg : 'Invalid otp' })
        
    }

    sendMail=()=>{
        const dets = { email : this.state.email ,otp : this.state.otp }
        axios.post("https://mail-api-node.herokuapp.com/edit/vendor",{details: dets})
        .then((req,res)=>{
            console.log(res)
            // https://mail-api-node.herokuapp.com/edWit/vendor
        })
        .catch(err=> console.log(err))
    }
    onSubmitDets=()=>{
        if((this.state.email==="" || this.state.service ==="")) return this.setState({ msg: "Can't be left empty" })
        firestore.collection("Services").doc(this.state.service).get().then(doc=>{
            const index= doc.data().data.findIndex(e=> e.email === this.state.email)
            if(index === -1) { this.setState({ data : null }) } 
            else  { 
                let copyofdata= { ...doc.data().data[index] }
                const otp = Math.floor(100000 + Math.random() * 900000).toString()
                this.setState({ otp : otp, data : copyofdata, buttons : true,index : index })
                this.sendMail()
            }   
            console.log(this.state)
        }).catch(err=>console.log(err.code))
        this.setState({ loading : true,msg : '' })               
     
        setTimeout(() => {
            this.setState({loading : false})
        }, 3000);
        
        }
    
        render() {
        return (
        
                this.state.edit ? <EditForm 
                Dets={this.state.data}
                index={this.state.index}
                /> : 

                <div >
                <Segment style={{ minHeight : "520px" }} placeholder>
              
                <Search 
                loading={this.state.loading} 
                submit={this.onSubmitDets} 
                get={(e)=>this.getDets(e)} 
                dropdown={(event)=>this.getService(event)}
                values={this.state}
                getOtp={(e)=>this.getOtp(e)}
                confirm={this.confirmOtp}
                />
                
                {
                    this.state.data ? 
                    <Details 
                    Dets={this.state.data} 
                    otpSuccess={this.state.success} 
                    edit={this.gotoEdit}
                    initials={this.init}
                    /> : ''
                }
                </Segment>
            </div>

        )
    }
}

export default Editvendor
